<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Create Diode</div>
    <form @submit.prevent="submit">
      <c-text-input v-model="data.serial" label="Serial" placeholder="xx-xxxx-xxxxxx" :error="errors.serial"/>
      <c-text-input v-model="data.name" label="Name" placeholder="Pump 10" :error="errors.name"/>
      <c-text-input v-model="data.location" label="Location" placeholder="Facility 10" :error="errors.location"/>
      <diode-user-select v-model="data.user"/>
      <div class="pt-5">
        <button class="button is-primary is-fullwidth">Create</button>
      </div>
    </form>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import DiodeUserSelect from './diode-user-select';
import api from '@/api';


export default {
  name: 'create-diode-form',
  components: {
    DiodeUserSelect
  },
  data () {
    return {
      data: {
        user: null
      },
      errors: {}
    };
  },
  methods: {
    save(dump) {
      var blob = new Blob([JSON.stringify(dump, null, 2)], {type: "text/plain;charset=utf-8"});
      saveAs(blob, `${dump.serial}.json`);
    },
    async submit() {
      try {
        if (!this.data.user) this.data.user = undefined;
        const dump = await api.admin.diodes.create(this.data);
        this.save(dump);
        this.errors = {};
        this.data = {user: null};
        this.$emit('complete');
      } catch (error) {
        this.handle(error);
      }
    },
    handle(error) {
      const errors = error.data;
      this.errors = {};
      if (errors.serial) this.errors.serial = 'Please enter a serial number.';
      if (errors.user) this.errors.user = 'Please select a valid user.';
      if (errors.name) this.errors.name = 'Please select a valid name.';
      if (errors.location) this.errors.location = 'Please select a valid location.';
    }
  }
};
</script>
